/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export { default as Page } from './Page';
export { default as PageLayout } from './PageLayout';
export { default as PageHeader } from './PageHeader';
export { default as PageDefault } from './PageDefault';
